import { useEffect } from 'react';

let Page = ({ children }) => {
  // Set the canonical URL && og:url to the current URL.
  useEffect(() => {
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', window.location.href);
    }

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', window.location.href);
    }
  }, []);
  return (
    <div className="px-4 mx-auto alignwide sm:px-6 lg:px-8 pb-12 max-w-[75rem]">
      {children}
    </div>
  );
};

export default Page;
